import BaseAnnotationLayer from "./BaseAnnotationLayer";
import {markAnnotation} from "../utils/annotations_app_utils";
import {getStyleForBloodAnnotation, resetAnnotationStyle} from "../utils/map_utils";
import {isBloodDebug} from "../../../utils/const";

class FieldLayer extends BaseAnnotationLayer {
	id = "field";
	label = "Field Layer";
	drawer = 4;

	getText = (annoStyle) => isBloodDebug ? annoStyle.setText(this.baseText) : null;

	onFeatureSelect = (feature) => {
		resetAnnotationStyle();
		getStyleForBloodAnnotation(feature);
		markAnnotation(this.props.map.get('id'), feature.getProperties().annotation);
	}
}

export default FieldLayer;
